// ControlVerticalSeparatorFactory.js
import $ from 'jquery';

import BaseVisualControlFactory	from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import HorizontalSeparatorControlView from 'advanced-visuals/HorizontalSeparatorControlView.js';

//=============================================================================
//
// Creates a horizontal separator control, given a factoryService
// parameter key and a layout postion. The factory key defines the initial
// rectangle of the control via a width and height from the factory parameter.
//
// -Lou Mauget, December 8, 2015 
//
//=============================================================================
class ControlHorizontalSeparatorFactory extends BaseVisualControlFactory {
	constructor () {
		super();
	}

	createView( factoryKey, pos ) {
  		const attributes = this.createChildAttributes(  factoryKey, pos ) ;
		attributes.silent = false;
		attributes.height=  '~seperatorSize';
		attributes.lineColor = '~seperatorColor';
        attributes.resizePadding = 2;
		attributes.minWidth = 10;
		attributes.minHeight = 1;
  		
        return new HorizontalSeparatorControlView( { 
        	model: new ControlModel( attributes ), 
        	el: $(constants.FORM_ID),  
			pos: pos, 
			factoryKey: factoryKey, 
			id: attributes.id } );
	}

}

const controlHorizontalSeparatorFactory = new ControlHorizontalSeparatorFactory();
export default controlHorizontalSeparatorFactory;
